<div color="primary" class="dropdown-defnyddiwr" [matMenuTriggerFor]="dewisdefnyddiwr" matRipple>
  <div class="enw-defnyddiwr"><fa-icon icon="user" class="mr-1"></fa-icon> {{ enwDefnyddiwr }}</div>
</div>
<mat-menu #dewisdefnyddiwr="matMenu" class="menu-defnyddiwr">
  <button mat-menu-item (click)="allgofnodi()"><fa-icon icon="sign-out-alt"></fa-icon> {{ "ui.allgofnodi" | translate }}</button>
</mat-menu>